import styled from 'styled-components';

import {Label, Text} from '~components/atoms/Text';
import ArrowLeftIcon from '~assets/images/icons/ui/arrow-left.svg';

export const ResultsContainerPlaceholder = styled.div`
    width: 100%;
    position: relative;
    height: 0;
    z-index: 15;
    display: none;
`;

export const SearchbarContainer = styled.div`
    width: 100%;
    z-index: 15;

    &:focus-within ${ResultsContainerPlaceholder} {
        display: block;
    }
`;

export const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    margin: 30px 0;
`;

export const ResultsContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    min-height: 80px;
    max-height: 80vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    background: white;
    padding-top: 16px;
    padding-bottom: 16px;
`;

export const Section = styled.div`
    padding: 4px 16px;

    & > * {
        margin-bottom: 12px !important;
    }
`;

export const SectionName = styled(Label).attrs({
    as: 'h6',
})`
    margin: 12px 0;
`;

export const TextButton = styled(Text).attrs({
    as: 'button',
})`
    background: none;
    margin: 0;
    padding: 0;
    border: none;
    appearance: none;
    cursor: pointer;
    display: flex;
    align-items: center;
`;

export const ArrowRight = styled(ArrowLeftIcon)`
    transform: scale(-1, -1) translateY(-2px);
    margin-left: 8px;
`;
